"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSidebarToggle = void 0;
var _react = require("react");
var _material = require("@mui/material");
const useSidebarToggle = () => {
  const isSmallScreen = (0, _material.useMediaQuery)(theme => theme.breakpoints.down('md'));
  const [collapsed, setCollapsed] = (0, _react.useState)(isSmallScreen);
  const handleClick = () => {
    setCollapsed(!collapsed);
  };
  return {
    collapsed,
    handleClick
  };
};
exports.useSidebarToggle = useSidebarToggle;